// src/components/reports/CompanyTrendReport/TrendTable.tsx

import React from 'react';
import {
  Typography,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper
} from '@mui/material';
import { CompanyTrendReportItem, formatCurrency, formatProfitRate, formatYoYRate, formatPeriodLabel } from '../../../../types/sales';

interface TrendTableProps {
  data: CompanyTrendReportItem[];
}

export const TrendTable: React.FC<TrendTableProps> = ({ data }) => {
  if (!data || data.length === 0) {
    return (
      <Typography variant="body1">
        表示するデータがありません。
      </Typography>
    );
  }

  return (
    <>
      <Typography variant="subtitle1" gutterBottom sx={{ mt: 4 }}>
        期間別売上・利益推移
      </Typography>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>期間</TableCell>
              <TableCell align="right">完了工事数</TableCell>
              <TableCell align="right">売上金額</TableCell>
              <TableCell align="right">前年同期比</TableCell>
              <TableCell align="right">粗利益</TableCell>
              <TableCell align="right">粗利益率</TableCell>
              <TableCell align="right">職長手当</TableCell>
              <TableCell align="right">最終利益</TableCell>
              <TableCell align="right">最終利益率</TableCell>
              <TableCell align="right">利益前年比</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((item: CompanyTrendReportItem) => (
              <TableRow key={item.period}>
                <TableCell>{formatPeriodLabel(item.period)}</TableCell>
                <TableCell align="right">{item.project_count}</TableCell>
                <TableCell align="right">{formatCurrency(item.total_sales)}</TableCell>
                <TableCell
                  align="right"
                  sx={{ color: item.sales_yoy && item.sales_yoy > 0 ? 'success.main' : 'error.main' }}
                >
                  {formatYoYRate(item.sales_yoy)}
                </TableCell>
                <TableCell
                  align="right"
                  sx={{ color: item.gross_profit < 0 ? 'error.main' : 'success.main' }}
                >
                  {formatCurrency(item.gross_profit)}
                </TableCell>
                <TableCell align="right">{formatProfitRate(item.gross_profit_rate)}</TableCell>
                <TableCell align="right">{formatCurrency(item.supervisor_allowance)}</TableCell>
                <TableCell
                  align="right"
                  sx={{ color: item.final_profit < 0 ? 'error.main' : 'success.main' }}
                >
                  {formatCurrency(item.final_profit)}
                </TableCell>
                <TableCell align="right">{formatProfitRate(item.final_profit_rate)}</TableCell>
                <TableCell
                  align="right"
                  sx={{ color: item.profit_yoy && item.profit_yoy > 0 ? 'success.main' : 'error.main' }}
                >
                  {formatYoYRate(item.profit_yoy)}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};